import { v4 as uuidv4 } from 'uuid';
import API from '../config/API';

const Event = {
  START: "START",
  SCAN: "SCAN",
  UPLOAD: "UPLOAD"
};

const logEvent = (payLoad) => {
  API.scanStationUsage.post('/event', payLoad).then(response => {
    console.log(response);
  }).catch(error => {
    console.error(error);
  });
};

const startSession = (packageName) => {
  try {
    if (!getSessionData("sessionId")) {
      const sessionId = uuidv4();
      const deviceId = uuidv4();
      setSessionData("sessionId", sessionId);
      setSessionData("datetime", new Date());
      setSessionData("packageName", packageName);
      setSessionData("deviceId", deviceId);
      setSessionData("location", window.location.hostname);

      const payLoad = {
        "timestamp" : new Date(),
        "type": Event.START,
        "packageName": packageName,
        "deviceId": deviceId,
        "location": window.location.hostname,
        "serviceAreaLabel": null,
        "serviceAreaCode": null,
        "evidenceTypeCode": null,
        "evidenceTypeLabel": null,
        "sessionId": sessionId,
        "sessionLength": 0,
        "pageCount": 0,
        "activity": "App",
        "verificationRequired": false
      };
      logEvent(payLoad);
    }
  }
  catch (error) {
    console.error(error);
  }
};

const logScanEvent = (serviceArea, evidenceType, pageCount, activity) => {
  try {
    const sessionStartTime = new Date(getSessionData("datetime"));
    const now = new Date().getTime();
    const sessionLength = Math.floor(((now - sessionStartTime)/1000)/60);
    const payLoad = {
      "timestamp" : new Date(),
      "type": Event.SCAN,
      "packageName": getSessionData("packageName"),
      "deviceId": getSessionData("deviceId"),
      "location": getSessionData("location"),
      "serviceAreaLabel": serviceArea.label || null,
      "serviceAreaCode": serviceArea.id || null,
      "evidenceTypeLabel": evidenceType.label || null,
      "evidenceTypeCode": evidenceType.id || null,
      "sessionId": getSessionData("sessionId"),
      "sessionLength": sessionLength, //in minutes;
      "pageCount": pageCount,
      "activity": activity,
      "verificationRequired": false
    };
    logEvent(payLoad);
  }
  catch (error) {
    console.error(error);
  }
};

const logUploadEvent = (serviceArea, evidenceType, pageCount) => {
  try {
    const sessionStartTime = new Date(getSessionData("datetime"));
    const now = new Date().getTime();
    const sessionLength = Math.floor(((now - sessionStartTime)/1000)/60);
    const payLoad = {
      "timestamp" : new Date(),
      "type": Event.UPLOAD,
      "packageName": getSessionData("packageName"),
      "deviceId": getSessionData("deviceId"),
      "location": getSessionData("location"),
      "serviceAreaLabel": serviceArea.label || null,
      "serviceAreaCode": serviceArea.id || null,
      "evidenceTypeLabel": evidenceType.label || null,
      "evidenceTypeCode": evidenceType.id || null,
      "sessionId": getSessionData("sessionId"),
      "sessionLength": sessionLength, //in minutes;
      "pageCount": pageCount,
      "activity": "EvidenceSubmitter",
      "verificationRequired": false
    };
    logEvent(payLoad);
  }
  catch (error) {
    console.error(error);
  }
};

const setSessionData = (key, value) => {
  if (hasStorage()) sessionStorage.setItem(key, value);
  else document.cookie = key+"="+ JSON.stringify(value);
};

const getSessionData = (key) => {
  let value = null;
  if (hasStorage()) value = sessionStorage.getItem(key);
  else {
    const cookie = getCookie(key);
    if (cookie) value = cookie.substring(cookie.indexOf('=') + 1);
  }
  return value;
};

const getCookie = (key) => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(key + "=");
    if (cStart !== -1) {
      cStart = cStart + key.length + 1;
      var cEnd = document.cookie.indexOf(";", cStart);
      if (cEnd === -1) cEnd = document.cookie.length;
      return decodeURI(document.cookie.substring(cStart, cEnd));
    }
  }
  return null;
};

const hasStorage = () => {
  try {
    sessionStorage.setItem('foo', 'bar');
    sessionStorage.removeItem('foo');
    return true;
  } catch (exception) {
    return false;
  }
};

export { startSession, logUploadEvent, logScanEvent };
